import { cn } from "@qw/ui";

export const Shiny = ({ children, className, disabled, ...props }: React.ComponentProps<"button">) => (
  <button
    disabled={disabled}
    className={cn(
      "group bg-qw-orange filled flex items-center justify-center overflow-hidden outline-none relative rounded-md size-8 transition-colors disabled:bg-muted-foreground",
      "disabled:bg-muted-foreground! disabled:opacity-50 disabled:pointer-events-none",
      className
    )}
    {...props}
  >
    <div className="absolute bg-qw-yellow inset-0 mix-blend-overlay rounded-full origin-top rotate-60 translate-y-2 animate-spin duration-15000 group-disabled:hidden" />
    <div className="absolute backdrop-blur-md inset-0" />
    <div className="absolute flex font-bold inset-0 items-center justify-center text-[17px] text-primary-foreground group-disabled:opacity-50">
      {children}
    </div>
  </button>
);
